import { combineReducers } from 'redux';
import IntlReducer from './IntlReducer';
import UserInforReducer from './UserInforReducer';
import BackDropReducer from './BackDropReducer';
import ConfirmDialogReducer from './ConfirmDialogReducer';
import SnackbarAlertReducer from './SnackbarAlertReducer';

const Reducer = combineReducers(
    {
        Intl: IntlReducer,
        UserInfor: UserInforReducer,
        BackDrop: BackDropReducer,
        ConfirmDialog: ConfirmDialogReducer,
        SnackbarAlert: SnackbarAlertReducer,
    }
)

export default Reducer;
